import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { NavigationMenuCardComponent } from './navigation-menu-card/navigation-menu-card.component';
import { NavigationMenuLinkComponent } from './navigation-menu-link/navigation-menu-link.component';
import { NavigationMenuListComponent } from './navigation-menu-list/navigation-menu-list.component';
import { NavigationMenuNavItemComponent } from './navigation-menu-nav-item/navigation-menu-nav-item.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [
    NavigationMenuCardComponent,
    NavigationMenuListComponent,
    NavigationMenuLinkComponent,
    NavigationMenuNavItemComponent,
  ],
  exports: [
    NavigationMenuCardComponent,
    NavigationMenuListComponent,
    NavigationMenuLinkComponent,
    NavigationMenuNavItemComponent,
  ],
})
export class NavigationMenuModule {}
